<template>
  <el-form v-if="Object.values(targetingForm).length">
    <LabelRow label="计划场景：" v-if="adMarketingSceneType.version3"> 腾讯3.0 </LabelRow>
    <LabelRow label="计划场景：" v-if="adMarketingSceneType.version_smart"> 腾讯-智投</LabelRow>
    <LabelRow label="计划场景：" v-if="adMarketingSceneType.version_search"> 搜索</LabelRow>
    <LabelRow label="定向模式：" v-if="adMarketingSceneType.version3">{{ targetingForm.smart_targeting_mode ? '手动定向已开启，当前为手动定向模式' : '手动定向已关闭，当前为智能定向模式' }}</LabelRow>
    <LabelRow label="计划形式：">{{ targetingForm.automatic_site_enabled ? '自动版位' : '手动版位' }}</LabelRow>
    <LabelRow label="版位：" v-if="sietSetNames">{{ sietSetNames }}</LabelRow>

    <template v-if="hasPcQQ">
      <LabelRow label="腾讯电脑端定投：">{{ pcScenes }}</LabelRow>
    </template>

    <template v-if="hasWechat">
      <LabelRow label="微信公众号与小程序定投：">{{ wechatPostions }}</LabelRow>
      <LabelRow label="微信公众号与小程序场景：">
        <p>公众号媒体类型：{{ wechatScenes }}</p>
        <p>小程序小游戏流量类型：{{ miniGameStream }}</p>
        <p>订单详情页消费场景：{{ payScenes }}</p>
      </LabelRow>
    </template>
    <template v-if="hasWechatChannels">
      <LabelRow label="微信视频号定投：">{{ wechatChannels }}</LabelRow>
    </template>

    <template v-if="hasUnion">
      <LabelRow label="优量汇展示场景：">{{ displayScenes }}</LabelRow>
      <LabelRow label="优量汇自动流量优选：">{{ targetingForm.flow_optimization_enabled ? '开启' : '关闭' }}</LabelRow>
      <LabelRow label="优量汇流量包屏蔽：">{{ excludeUnionPositionPackages }}</LabelRow>
    </template>

    <template v-if="adMarketingSceneType.version_search">
      <LabelRow label="版位：" v-if="searchAdSietSetNames">{{ searchAdSietSetNames }}</LabelRow>
      <LabelRow label="QQ浏览器等流量场景：" v-if="searchAdScenes.qbsearch_scene">{{ searchAdScenes.qbsearch_scene }}</LabelRow>
      <LabelRow label="微信搜一搜流量场景：" v-if="searchAdScenes.wechat_search_scene">{{ searchAdScenes.wechat_search_scene }}</LabelRow>
      <LabelRow v-if="searchAdScenes.keywordsCount" label="关键词：">
        {{ searchAdScenes.keywords }}共{{ searchAdScenes.keywordsCount }}个关键词
      </LabelRow>
      <LabelRow label="微信再营销："> {{ wechatAdBehaviors }} </LabelRow>
    </template>

    <template v-if="adMarketingSceneType.version3">
      <LabelRow label="地域："> {{ regions }} </LabelRow>
      <LabelRow label="地点类型："> {{ locationTypes }} </LabelRow>
    </template>
    <LabelRow label="性别："> {{ genders }} </LabelRow>
    <LabelRow label="年龄："> {{ ages }} </LabelRow>
    <LabelRow label="手机品牌：" v-if="adMarketingSceneType.version3"> {{ mobileBrands }} </LabelRow>
    <LabelRow label="系统版本："> {{ systemVersions }} </LabelRow>
    <LabelRow label="微信再营销：" v-if="adMarketingSceneType.version_smart"> {{ wechatAdBehaviors }} </LabelRow>
    <template v-if="adMarketingSceneType.version3">
      <LabelRow label="网络："> {{ networks }} </LabelRow>
      <LabelRow label="游戏消费能力："> {{ gameConsumptionLevels }} </LabelRow>
      <LabelRow label="微信再营销："> {{ wechatAdBehaviors }} </LabelRow>
      <LabelRow label="设备价格："> {{ devecePrices }} </LabelRow>
    </template>
    <LabelRow label="排除已转化：" v-if="targetingForm.excludeCustom"> {{ excludeConversions }} </LabelRow>
  </el-form>
</template>

<script setup>
import { ref, computed } from 'vue'
import { clone } from '@/common/js/just.js'
import LabelRow from '@/views/create/bytedance/components/layout/label-row.vue'
import {
  getSiteSetInitList,
  useInitialTargetingForm,
  useAccountList,
  useAudience,
  useAge,
  useRegion,
  useDevice,
  useDeviceOS,
  useExcludeConversion,
  useSiteSet
} from '@/views/promote/targeting/components/gdtv3/useGdtv3TargetingForm.js'
import {
  AUDIENCES_TYPE,
  AGES,
  NETWORKS,
  DEVICE_PRICES,
  CONVERSION_BEHAVIOR_LIST,
  DISPLAY_SCENE_LIST,
  LOCATION_TYPES_LIST,
  WECHAT_AD_BEHAVIORS_LIST,
  EXCLUDED_CONVERSIONS_LIST,
  EXCLUDED_DAY,
  WECHAT_AD_BEHAVIORS_REGISTERED_ACTIVITY
} from '@/views/create/gdt/model/targeting-const.js'
import { AD_MARKETING_SCENE } from '@/views/create/gdt/model/project-const.js'
import {
  SITE_SET_LIST,
  SEARCH_AD_SITE_SET_LIST,
  SITE_ENUM,
  WECHAT_SITES,
  EXPLORATION_ENUM
} from '@/views/create/gdt/model/siteset/siteset-const.js'
import { isArray } from '@/common/js/utils'

const targetingForm = ref({})
// eslint-disable-next-line
const props = defineProps({
  form: {
    type: Object,
    required: true
  }
})

if (props.form.targetingParamJson) {
  targetingForm.value = clone(props.form.targetingParamJson)
}

const searchAdSietSetNames = computed(() => {
  const { siteSet } = targetingForm.value
  const searchAdSiteSets = []

  siteSet?.forEach((site) => {
    const siteItem = SEARCH_AD_SITE_SET_LIST.find((s) => s.label === site)
    if (siteItem) searchAdSiteSets.push(siteItem.name)
  })

  return searchAdSiteSets.join('、')
})

const sietSetNames = computed(() => {
  const automatic_sites_arr = []
  const manual_sites_arr = []
  const { siteSet, priority_site_set, automatic_site_enabled, exploration_strategy } = targetingForm.value

  siteSet?.forEach((site) => {
    const siteItem = SITE_SET_LIST.find((s) => s.label === site)
    if (siteItem) manual_sites_arr.push(siteItem.name)
  })
  priority_site_set?.forEach((site) => {
    const siteItem = SITE_SET_LIST.find((s) => s.label === site)
    if (siteItem) automatic_sites_arr.push(siteItem.name)
  })
  // 自动版位，且为稳步探索返回版位
  if (automatic_site_enabled && exploration_strategy === EXPLORATION_ENUM.STEADY) {
    return automatic_sites_arr.join('、')
  }
  // 手动版位返回版位
  if (!automatic_site_enabled) {
    return manual_sites_arr.join('、')
  }
  // 其他不显示
  return false
})

const { getUnionPackages, currUnionPackageAccountId, setSetInitData, unionPositionPackages } = useSiteSet()
// const { getAudienceData, audiencesData } = useAudience()
const { filterdCityData } = useRegion()
const { deviceBrandData, getDeviceData } = useDevice()
const { deviceVersionData } = useDeviceOS()
currUnionPackageAccountId.value = props.form.accountIds
getUnionPackages()
// getAudienceData(props.form.accountIds)
getDeviceData(props.form.accountIds)

const adMarketingSceneType = computed(() => {
  const { ad_marketing_scene } = targetingForm.value
  return {
    version3: typeof ad_marketing_scene === 'undefined' || ad_marketing_scene === AD_MARKETING_SCENE.VERSION_3,
    version_smart: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART,
    version_search: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH
  }
})

const hasPcQQ = computed(() => {
  const { siteSet } = targetingForm.value
  return siteSet.includes(SITE_ENUM.PCQQ)
})

const hasWechat = computed(() => {
  const { siteSet } = targetingForm.value
  return siteSet.includes(SITE_ENUM.WECHAT)
})
const hasWechatChannels = computed(() => {
  const { siteSet, automatic_site_enabled } = targetingForm.value
  return siteSet.includes(SITE_ENUM.CHANNELS) || automatic_site_enabled
})
const hasUnion = computed(() => {
  const { siteSet } = targetingForm.value
  return siteSet.includes(SITE_ENUM.MOBILE_UNION)
})

const wechatChannels = computed(() => {
  const { wechatChannelPositions } = setSetInitData.value
  if (!targetingForm.value.wechatChannels?.length) return '不限'
  if (!targetingForm.value.wechat_channels) return '不限'

  const arr = []
  targetingForm.value.wechatChannels.forEach((id) => {
    const item = wechatChannelPositions.find((o) => o.id === id)
    if (item) {
      arr.push(item.description)
    }
  })
  return arr.join('、')
})

const pcScenes = computed(() => {
  const { pcScenes } = setSetInitData.value
  const { pcScene } = targetingForm.value
  if (!pcScene?.length) return '不限'
  const arr = []
  pcScene.forEach((id) => {
    const item = pcScenes.find((p) => p.value === id)
    if (item) {
      arr.push(item.label)
    }
  })
  return arr.join('、')
})

const wechatPostions = computed(() => {
  const { wechatPositions } = setSetInitData.value
  if (!wechatPositions?.length) return '不限'
  if (!targetingForm.value.wechatPostion?.length) return '不限'

  const arr = []
  targetingForm.value.wechatPostion.forEach((id) => {
    const item = wechatPositions.find((p) => p.id === id)
    if (item) {
      arr.push(item.description)
    }
  })

  return arr.join('、')
})

const wechatScenes = computed(() => {
  const { officialAccountMediaCates } = setSetInitData.value
  if (!officialAccountMediaCates?.length) return '不限'
  if (!targetingForm.value.officialAccountMediaCate?.length) return '不限'

  const arr = []
  targetingForm.value.officialAccountMediaCate.forEach((id) => {
    const item = officialAccountMediaCates.find((o) => o.id === id)
    if (item) {
      arr.push(item.description)
    }
  })

  return arr.join('、')
})

const miniGameStream = computed(() => {
  const { miniGames } = setSetInitData.value
  if (!miniGames?.length) return '不限'
  if (!targetingForm.value.miniGame?.length) return '不限'

  const arr = []
  targetingForm.value.miniGame.forEach((id) => {
    const item = miniGames.find((m) => m.id === id)
    if (item) {
      arr.push(item.description)
    }
  })

  return arr.join('、')
})

const payScenes = computed(() => {
  const { payScenes } = setSetInitData.value
  if (!payScenes?.length) return '不限'
  if (!targetingForm.value.payScene?.length) return '不限'

  const arr = []
  targetingForm.value.payScene.forEach((id) => {
    const item = payScenes.find((p) => p.id === id)
    if (item) {
      arr.push(item.description)
    }
  })

  return arr.join('、')
})

const displayScenes = computed(() => {
  const { scene_spec } = targetingForm.value
  if (!scene_spec.display_scene?.length) return '不限'
  const arr = []
  scene_spec.display_scene.forEach((value) => {
    const item = DISPLAY_SCENE_LIST.find((s) => s.value === value)
    if (item) {
      arr.push(item.label)
    }
  })

  return arr.join('、')
})

const searchAdScenes = computed(() => {
  const { qbsearch_scene, qbSearchScene, wechat_search_scene, wechatSearchScene, searchAdBidKeywords } = targetingForm.value
  return {
    qbsearch_scene: qbsearch_scene && qbSearchScene?.length ? '移动QQ浏览器等' : '',
    wechat_search_scene: wechat_search_scene && wechatSearchScene?.length ? '移动微信搜一搜' : '',
    keywords: searchAdBidKeywords
      ?.map((s) => s.keyword)
      .slice(0, 3)
      .join('、'),
    keywordsCount: searchAdBidKeywords?.length
  }
})

const excludeUnionPositionPackages = computed(() => {
  const { scene_spec } = targetingForm.value
  const [excludePackages] = Object.values(scene_spec.exclude_union_position_package)
  if (!excludePackages?.length) return '不限'
  const arr = []
  excludePackages.forEach((id) => {
    const item = unionPositionPackages.value.find((s) => s.id === id)
    if (item) {
      arr.push(item.value)
    }
  })
  return arr.join('、')
})

function getKeyValueByIdLoop(list, source, res = []) {
  for (let i = 0; i < list.length; i++) {
    const item = list[i]
    if (source.includes(item.id)) {
      res.push(item)
    }

    if (item.children) {
      getKeyValueByIdLoop(item.children, source, res)
    }
  }

  return res
}

const regions = computed(() => {
  const { regionType, region } = targetingForm.value
  if (regionType === 0) return '不限'
  const arr = getKeyValueByIdLoop(filterdCityData.value, region)
  return arr.map((item) => item.value).join('、')
})

const locationTypes = computed(() => {
  const { locationTypes } = targetingForm.value
  const arr = []
  locationTypes.forEach((value) => {
    const item = LOCATION_TYPES_LIST.find((l) => l.value === value)
    if (item) arr.push(item.label)
  })
  return arr.join('、')
})

const genders = computed(() => {
  const { gender } = targetingForm.value
  if (!gender) return '不限'
  return gender === 'MALE' ? '男' : '女'
})

const ages = computed(() => {
  const { age, ageRange } = targetingForm.value
  if (!age) return '不限'

  if (typeof age === 'string' && age.includes(',')) {
    const [min, max] = age.split(',')
    return `${min}~${max}`
  }
  if (isArray(age)) {
    return `${age[0]}~${age[1]}`
  }
  // 自定义年龄段
  if (age === 1 && ageRange.length) {
    const [min, max] = ageRange
    return `${min}~${max === 66 ? '66岁及以上' : max}`
  }

  return ''
})

const mobileBrands = computed(() => {
  const { deviceType, device } = targetingForm.value
  if (!deviceType) return '不限'
  const arr = getKeyValueByIdLoop(deviceBrandData.value, device)
  return arr.map((item) => item.value).join('、')
})

const systemVersions = computed(() => {
  const { version, osType } = targetingForm.value
  if (!osType) return '不限'
  const arr = getKeyValueByIdLoop(deviceVersionData, version)
  return arr.map((item) => item.value).join('、')
})

const networks = computed(() => {
  const { network } = targetingForm.value
  const [networkValue] = network
  if (!networkValue) return '不限'
  const arr = []
  network.forEach((value) => {
    const item = NETWORKS.find((n) => n.label === value)
    if (item) arr.push(item.value)
  })
  return arr.join('、')
})

const gameConsumptionLevels = computed(() => {
  const { game_consumption_level } = targetingForm.value
  const [value] = game_consumption_level || []
  if (!value) return '不限'
  return value === 'HIGH' ? '高' : '普通'
})

const wechatAdBehaviors = computed(() => {
  const { wechatAdBehaviorType, wechatAdBehavior } = targetingForm.value
  if (!wechatAdBehaviorType) return '不限'

  const { excluded_actions, actions, mini_game_wechat_registered_activity } = wechatAdBehavior

  const excludesArr = []
  const includesArr = []
  if (excluded_actions.length) {
    excluded_actions.forEach((value) => {
      const item = WECHAT_AD_BEHAVIORS_LIST.find((s) => s.value === value)
      if (item) excludesArr.push(item.label)
    })
  }

  if (actions.length) {
    actions.forEach((value) => {
      const item = WECHAT_AD_BEHAVIORS_LIST.find((s) => s.value === value)
      if (item) includesArr.push(item.label)
    })
  }

  const text = `再营销：${includesArr.length ? includesArr.join('、') : '无'}; 排除营销：${
    excludesArr.length ? excludesArr.join('、') : '无'
  }`

  const isIncludeRegister = excluded_actions.includes('MINI_GAME_WECHAT_REGISTERED') || actions.includes('MINI_GAME_WECHAT_REGISTERED')
  const { label } = WECHAT_AD_BEHAVIORS_REGISTERED_ACTIVITY.find((i) => i.value === mini_game_wechat_registered_activity) || {}
  return isIncludeRegister ? text.concat(`; 已注册用户活跃度：${label}`) : text
})

const devecePrices = computed(() => {
  const { devicePrice } = targetingForm.value
  const [priceValue] = devicePrice
  if (!priceValue) return '不限'
  const arr = []
  devicePrice.forEach((value) => {
    const item = DEVICE_PRICES.find((s) => s.value === value)
    if (item) arr.push(item.label)
  })
  return arr.join('、')
})

const excludeConversions = computed(() => {
  const { excluded_converted_audience } = targetingForm.value
  const { excluded_dimension, conversion_behavior_list, excluded_day } = excluded_converted_audience
  if (!excluded_dimension) return '不限'
  let str = EXCLUDED_CONVERSIONS_LIST.find((s) => s.value === excluded_dimension).label
  const arr = []
  conversion_behavior_list.forEach((value) => {
    const item = CONVERSION_BEHAVIOR_LIST.find((s) => s.value === value)
    if (item) arr.push(item.label)
  })

  if (arr?.length) {
    str += `；自定义转化行为：${arr.join('、')}`
  }
  if (excluded_day) {
    const days = excluded_day === EXCLUDED_DAY.ONE_DAY ? '当天' : excluded_day === EXCLUDED_DAY.SEVEN_DAY ? '7天' : '1个月'
    str += `；转化时间区间：${days}`
  }

  return str
})
</script>

<style lang="scss" scoped></style>
